export const COMToggledElementBehavior = function(superClass) {

  return class extends superClass {
    static get properties() {
      return {
        checked: Boolean,
        disabled: Boolean,
        error: Boolean,
        noink: Boolean,
        hover: Boolean,
        /**
         * @desc used internally for styling.
         * Slotted content will have cursor pointer if there are no [toggle-button] elements
         * @type Boolean
         */
        hasToggles: Boolean,
        ariaId: String
      };
    }

    ready() {
      super.ready();

      // create hover events
      this._mouseEnter = this._addHover.bind(this);
      this._mouseLeave = this.removeHover.bind(this);

      let setupToggles = () => {
        // check if slotted content has [toggle-button]
        let elems = this._getToggles();
        this.hasToggles = elems.length > 0;

        //add hover listeners to slotted [toggle-button]
        elems.forEach(toggleButton => {
          // cleanup existing listeners, just to make sure we don't double up events when slotchange occurs
          toggleButton.removeEventListener('mouseenter', this._mouseEnter, false);
          toggleButton.removeEventListener('mouseleave', this._mouseLeave, false);

          // add hover listners
          toggleButton.addEventListener('mouseenter', this._mouseEnter, false);
          toggleButton.addEventListener('mouseleave', this._mouseLeave, false);
        });
      };

      setupToggles();
      this.$.slot.addEventListener('slotchange', event => setupToggles);
    }

    /**
    * @desc Check if an element allows to toggle the component
    * @type {Event} event
    */
    checkToggleButton(event) {
      // Prevent toggle if component is disabled
      if (this.disabled) return;

      // If there are no [toggle-button] elements, all slotted content toggles the radio button
      let toggles = this._getToggles();
      if (toggles.length === 0) {
        this.checked = !this.checked;
        return;
      }

      // if there are [toggle-button] elements, then make sure the target is contained within
      let contained = false;
      toggles.forEach((elem) => {
        if (elem.contains(event.target)) {
          contained = true;
        }
      });

      if (contained) {
        this.checked = !this.checked;
        return;
      }
    }

    /**
     * @desc if there are no slotted [toggle-button] elements, then all slotted content toggles the component
     * Because all content toggles the component, then the hover effect applies when hovering over all slotted content.
     */
    checkAddHoverOnLabel() {
      if (this.hasToggles) return;
      this._addHover();
    }

    /**
     * @desc set hover to true
     */
    _addHover() {
      this.hover = true;
    }

    /**
     * @desc set hover to false
     */
    removeHover() {
      this.hover = false;
    }

    /**
     * @desc Get slotted content that has the [toggle-button] attribute
     * @return {HTMLElement[]} toggle-button elements
     */
    _getToggles() {
      let slotted = this.$.slot.assignedNodes({flatten:true})
        .filter(n => n.nodeType === Node.ELEMENT_NODE);

      let toggles = [];
      slotted.forEach((elem) => {
        if (elem.hasAttribute('toggle-button')) {
          toggles.push(elem);
        } else {
          let results = elem.querySelectorAll('[toggle-button]');
          results.forEach(result => toggles.push(result))
        }
      });

      return toggles;
    }

    /**
     * @desc Generate a random ID for a11y
     * @return randomString
     */
    generateRandId() {
      let result = '',
        length = 6,
        chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

      for (let i = length; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)];
      }

      return result;
    }
  };
};
